import CityPageTemplate from "../city-template/CityPageTemplate";
import { waukeshaConfig } from "./data";

export default function WaukeshaPage() {
  return <CityPageTemplate config={waukeshaConfig} />;
}